/* src/app/modules/search/components/doc-view/components/eml-view/eml-view.component.scss */
.eml-frame {
  display: block;
  width: 100%;
  border: none;
  overflow: auto;
}
.eml-frame::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.eml-frame::-webkit-scrollbar-track {
  background: none !important;
}
.eml-frame::-webkit-scrollbar-thumb {
  background: var(--primary-300) !important;
}
.eml-frame::-webkit-scrollbar-thumb:hover {
  background: var(--primary-500) !important;
}
/*# sourceMappingURL=eml-view.component.css.map */
